/* eslint-disable no-undef */
/* eslint-disable radix */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { NumberAlongAlphabetComparator,NumberAndAlphabetComparator, amountComparator } from '../../../../../SharedModules/utilities/utilities';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

export const checkGridTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_100,
    maxWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    pinned: 'left',
    lockPinned: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    sort: 'asc',
    editable: false,
    sortable: true,
    pinned: 'left',
    excelAlignment: 'right',
    lockPinned: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    dataAlignRight: true,
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    comparator: NumberAlongAlphabetComparator,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 4,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckIssuerCellRender',
    comparator: NumberAndAlphabetComparator,
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Beginning Unused Balance',
    field: 'beginingBalance',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,

    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'BeginningBalanceCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Allocated Amt',
    field: 'totAllocatedAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,

    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotAllocatedAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Remaining Unused Balance',
    field: 'endingBalance',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,

    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'EndingBalanceCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Suspended Date',
    field: 'suspendedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const TableHeaderForInvoiceGrid = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    columnSpan: 4,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'nameRenderMFG',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Rebate Program',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Quarter',
    field: 'qtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    autoHeight: true,
    wrapText: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Invoice Amt',
    field: 'totInvoiceAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    resizable: false,
    isTextColorRed: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotInvoiceAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const TableHeaderForQuarter = [
  {
    headerName: 'Actions',
    field: 'action',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: false,
    resizable: true,
    maxWidth: Styles.Width_100,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Invoice Reconciliation Quarter',
    field: 'invRecQtr',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_300,
    cellRenderer: 'NDCCellRender',
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Principal Paid',
    field: 'principalPaidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_250,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'principalPaidAmtRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Paid',
    field: 'interestPaidAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    isTextColorRed: true,
    minWidth: Styles.Width_200,
    resizable: false,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'interestPaidAmtRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
